import React from "react";

const JQuery_Reference_Selectors = () => {
  return (
    <div>
      <h1>JQuery_Reference_Selectors</h1>
      <p>Placeholder component for: "JQuery_Reference_Selectors"</p>
    </div>
  );
};

export default JQuery_Reference_Selectors;
